import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMDXComponents as _provideComponents } from "@mdx-js/react";
import HandPointingDownSparkles from '../../public/assets/landing/hand-pointing-down-sparkles@2x.png';
import ExerciseScreenshots from '../../public/assets/landing/exercise-screenshots@2x.png';
import Compass from '../../public/assets/landing/compass@2x.png';
import Wand from '../../public/assets/landing/wand@2x.png';
import FiveStarRating from '../../public/assets/landing/5-star-rating@2x.png';
import Shine from '../../public/assets/landing/shine@2x.png';
import MattPocock from '../../public/matt-pocock.jpg';
import MattInNewStudio from '../../public/assets/matt-in-new-studio@2x.jpg';
import { motion } from 'framer-motion';
function _createMdxContent(props) {
    const _components = Object.assign({
        h2: "h2",
        em: "em",
        p: "p",
        span: "span",
        strong: "strong",
        section: "section",
        div: "div",
        h3: "h3",
        svg: "svg",
        path: "path",
        code: "code",
        a: "a"
    }, _provideComponents(), props.components), { Testimonial, Image, Module, Buy, Companies } = _components;
    if (!Testimonial) _missingMdxReference("Testimonial", true);
    if (!Image) _missingMdxReference("Image", true);
    if (!Module) _missingMdxReference("Module", true);
    if (!Buy) _missingMdxReference("Buy", true);
    if (!Companies) _missingMdxReference("Companies", true);
    return _jsxs(_Fragment, {
        children: [
            _jsxs(_components.h2, {
                children: [
                    "You're good, but you want to be ",
                    _jsx(_components.em, {
                        children: "great"
                    })
                ]
            }),
            "\n",
            _jsx(_components.p, {
                children: "You could spend that time building new features or bugfixes. You could be providing value. Instead, you're fighting TypeScript."
            }),
            "\n",
            _jsx(_components.p, {
                children: "These days, TypeScript is an industry default. If you’re starting an enterprise app today, you’ll need a good reason NOT to use TypeScript."
            }),
            "\n",
            _jsx(_components.p, {
                children: "So you keep on pushing - all the time feeling like you’re working against TypeScript, not with it."
            }),
            "\n",
            _jsx(_components.p, {
                children: "The truth is that you never truly learned TypeScript, at least not in depth. That's the source of your pain."
            }),
            "\n",
            _jsx(_components.p, {
                children: "You never developed a systematic approach to solving type errors."
            }),
            "\n",
            _jsxs(_components.p, {
                children: [
                    "You never developed a mental model for understanding when to use ",
                    _jsx("span", {
                        className: "text-rose-400",
                        children: "any"
                    }),
                    "."
                ]
            }),
            "\n",
            _jsx(_components.p, {
                children: "You never understood the power of generics."
            }),
            "\n",
            _jsx(_components.p, {
                children: "Ultimately…"
            }),
            "\n",
            _jsx(_components.p, {
                children: _jsx(_components.strong, {
                    children: "You never learned the underlying principles and patterns of being an effective TypeScript engineer."
                })
            }),
            "\n",
            _jsx(_components.h2, {
                children: "Make TypeScript work for you, not against you"
            }),
            "\n",
            _jsx(_components.p, {
                children: "What’s the thing that separates TypeScript wizards from the rest?"
            }),
            "\n",
            _jsx(_components.p, {
                children: "Understanding."
            }),
            "\n",
            _jsx(_components.p, {
                children: "To them, TypeScript doesn’t feel like magic. It feels simple, predictable and malleable."
            }),
            "\n",
            _jsx(_components.p, {
                children: "They can bend it to their will, and use its power for amazing DX."
            }),
            "\n",
            _jsx(_components.p, {
                children: "Total TypeScript is all about building that understanding at a deep level."
            }),
            "\n",
            _jsx(_components.p, {
                children: "When you’ve completed the exercises, you’ll reach a point of mastery where very little surprises you any more."
            }),
            "\n",
            _jsxs(Testimonial, {
                className: "my-24 max-w-4xl mx-auto w-full [&_p]:italic text-center [&_blockquote]:items-center",
                author: {
                    name: "Laila Straube"
                },
                children: [
                    "I am sorry but I can not say it in different words. ",
                    _jsx(_components.strong, {
                        children: "THIS WORKSHOP IS FU^^ING AMAZING."
                    })
                ]
            }),
            "\n",
            _jsx(_components.p, {
                children: "You’ll have less fear when approaching nasty TypeScript errors, more confidence when typing dynamic signatures, gain velocity by cutting lines of code, and so much more."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "You deserve so much better"
            }),
            "\n",
            _jsx(_components.p, {
                children: "You deserve a practical, systematic approach to learning TypeScript in depth."
            }),
            "\n",
            _jsx(_components.p, {
                children: "Total TypeScript shows you the techniques used by the most complex OSS libraries."
            }),
            "\n",
            _jsx(_components.p, {
                children: "Become your company’s resident TypeScript Wizard."
            }),
            "\n",
            _jsxs(_components.p, {
                children: [
                    _jsx("span", {
                        className: "text-primary mr-2",
                        children: "✓"
                    }),
                    " You will become a better contributor and reviewer."
                ]
            }),
            "\n",
            _jsxs(_components.p, {
                children: [
                    _jsx("span", {
                        className: "text-primary mr-2",
                        children: "✓"
                    }),
                    " You will be the one to unblock others and raise their velocity."
                ]
            }),
            "\n",
            _jsxs(_components.p, {
                children: [
                    _jsx("span", {
                        className: "text-primary mr-2",
                        children: "✓"
                    }),
                    " You will be the one who knows instinctively what TypeScript is doing."
                ]
            }),
            "\n",
            _jsx(_components.p, {
                children: "You are indispensable."
            }),
            "\n",
            _jsxs("section", {
                className: "bg-background",
                children: [
                    _jsxs("div", {
                        className: "not-prose flex w-full flex-col items-center",
                        children: [
                            _jsx(Image, {
                                "aria-hidden": "true",
                                src: HandPointingDownSparkles,
                                alt: "hand pointing down with sparkles",
                                width: 512,
                                height: 633,
                                className: "select-none pointer-events-none mx-auto sm:-mt-24 -mt-16 sm:max-w-full max-w-[300px]"
                            }),
                            _jsx("h2", {
                                className: "text-center max-w-screen-lg text-balance font-text md:text-6xl sm:text-5xl text-4xl font-semibold pb-5",
                                children: "An exercise-driven approach for learning TypeScript"
                            }),
                            "\n",
                            _jsx("h3", {
                                className: "text-center text-primary max-w-screen-lg mb-8 text-balance font-sans sm:text-3xl text-xl font-normal",
                                children: "Total TypeScript's approach is different than what you'll find in other online courses."
                            })
                        ]
                    }),
                    _jsx(_components.p, {
                        children: "Instead of sitting through hours of lectures, you'll be presented with problematic code and a concise explanation of what needs to be done."
                    }),
                    _jsx(_components.p, {
                        children: "Then using your existing skills along helpful links to relevant docs and other resources, you'll have as much time as you need to complete the challenge either in your local editor or using the editor embedded into each lesson."
                    }),
                    _jsx(_components.p, {
                        children: "When you're ready, you can watch how a true TypeScript Wizard approaches solving the challenge."
                    }),
                    _jsx(_components.p, {
                        children: "The exercises build upon another, demonstrating the most important TypeScript concepts in a variety different contexts so you can build understanding of when, where, and how to best apply them in your own application and library code."
                    }),
                    _jsx(Testimonial, {
                        className: "my-24 max-w-4xl mx-auto w-full [&_p]:italic text-center [&_blockquote]:items-center",
                        author: {
                            name: 'Alex Tana',
                            image: require('../../public/testimonials/alex-tana.jpg')
                        },
                        children: _jsx(_components.p, {
                            children: "Total TypeScript is hands down the best course out there, and the format is the best I've seen. It feels like you're doing a 1 on 1 with Matt Pocock."
                        })
                    }),
                    _jsx(Image, {
                        src: ExerciseScreenshots,
                        className: "w-full lg:max-w-screen-lg max-w-[90vw] mx-auto",
                        loading: "eager",
                        quality: 100,
                        alt: "Total TypeScript screenshots"
                    })
                ]
            }),
            "\n",
            _jsx(Testimonial, {
                className: "my-24 max-w-4xl mx-auto w-full [&_p]:italic text-center [&_blockquote]:items-center",
                author: {
                    name: 'Jökull Sólberg',
                    image: require('../../public/testimonials/jokull-solberg.jpg')
                },
                children: _jsxs(_components.p, {
                    children: [
                        "The content itself was incredible. Videos are superb. Delivery, pacing, tone, everything- wow. ",
                        _jsx(_components.strong, {
                            children: "I feel like I have superpowers."
                        }),
                        " I’ve already made one library available!"
                    ]
                })
            }),
            "\n",
            _jsx(_components.h2, {
                children: "What you'll learn"
            }),
            "\n",
            _jsx(_components.p, {
                children: "Total TypeScript contains five professional-grade workshops for you to achieve TypeScript Wizardry."
            }),
            "\n",
            _jsxs(Testimonial, {
                className: "my-24 max-w-4xl mx-auto w-full [&_p]:italic text-center [&_blockquote]:items-center",
                author: {
                    name: 'Adam Rackis',
                    image: require('../../public/testimonials/adam-rackis.jpg')
                },
                children: [
                    _jsx(_components.p, {
                        children: "You know those kung fu movies where the hero has a training montage beating the shit out of a tree so he can get good & murder his enemy?"
                    }),
                    _jsx(_components.p, {
                        children: "That's what Matt Pocock's Total TypeScript is like. Except TS instead of Kung Fu. And Jira tickets instead of your enemy. Anyway it's great"
                    })
                ]
            }),
            "\n",
            _jsx(_components.p, {
                children: "Each workshop contains dozens of exercises designed to put your problem solving skills to the test."
            }),
            "\n",
            _jsx("section", {
                id: "workshops",
                className: "bg-gradient-to-b mt-16 pb-16 from-background to-black/40 border-b border-white/5 w-full flex flex-col",
                children: _jsxs("div", {
                    className: "flex flex-col gap-20 pb-24",
                    children: [
                        _jsxs(Module, {
                            title: "TypeScript Pro Essentials",
                            slug: "typescript-pro-essentials",
                            metaLabel: "200+ exercises",
                            sub: "Everything you need from setup to application development patterns",
                            image: "https://cdn.sanity.io/images/z9io1e0u/production/80da574ffbb12904f823723d5ea0a8e20add0270-1200x1200.png",
                            children: [
                                _jsx(_components.p, {
                                    children: "Whether you're new to the language or looking to reenforce your foundation, this workshop covers all of the essential TypeScript knowledge and skills you need."
                                }),
                                _jsx(_components.p, {
                                    children: "From setting up your dev environment through best practices for designing types, this workshop bridges the gap between TypeScript theory and practice with type manipulation techniques, OOP with classes, annotations, assertions, and more!"
                                })
                            ]
                        }),
                        _jsxs(Module, {
                            title: "Type Transformations",
                            slug: "type-transformations",
                            metaLabel: "50+ exercises",
                            sub: "Wield the power of transformation to move from one type to another with ease",
                            image: "https://cdn.sanity.io/images/z9io1e0u/production/8d26aee5def2397f419bb038fd8879286fd41bda-768x768.png",
                            children: [
                                _jsx(_components.p, {
                                    children: "Many problems in TypeScript come down to transforming types into other types."
                                }),
                                _jsx(_components.p, {
                                    children: "This workshop is your first step on the path to wizardry with topics including unions, template literals, conditional types and mapped types. You'll also see how to take advantage of inference and type helpers to ensure you retain flexibility while ensuring your types are exactly how you expect them to be."
                                })
                            ]
                        }),
                        _jsxs(Module, {
                            title: "TypeScript Generics",
                            slug: "typescript-generics",
                            metaLabel: "40+ exercises",
                            sub: "Unlock amazing inference in the functions you create and the abstractions you build",
                            image: "https://cdn.sanity.io/images/z9io1e0u/production/12ef51ed533404ccf132765c75be8b6fe600bcda-769x769.png",
                            children: [
                                _jsx(_components.p, {
                                    children: "Generics are one of TypeScript's most complex and intimidating features."
                                }),
                                _jsx(_components.p, {
                                    children: "Getting good at generics requires deep knowledge of the TypeScript Compiler, as well as an understanding of how their placement impacts their usefulness."
                                }),
                                _jsx(_components.p, {
                                    children: "You'll practice with using generics in a variety of situations, as well as how to use function overloads when generics aren't the best fit."
                                })
                            ]
                        }),
                        _jsxs(Module, {
                            title: "Advanced TypeScript Patterns",
                            slug: "advanced-typescript-patterns",
                            metaLabel: "40+ exercises",
                            sub: "Become fluent in TypeScript's undocumented patterns",
                            image: "https://cdn.sanity.io/images/z9io1e0u/production/ce94d457bbfa7580dd803aaa5630a7c6ebed9fee-927x927.png",
                            children: [
                                _jsx(_components.p, {
                                    children: "The TypeScript community has discovered and iterated upon several patterns that build on the type transformation and generics techniques explored in the earlier workshops."
                                }),
                                _jsx(_components.p, {
                                    children: "Here you'll grow more powerful through practice with branded types and the builder pattern, among others. You will also discover the best practices for strongly typing the global scope and how to understand the flow of generics through external libraries."
                                })
                            ]
                        }),
                        _jsxs(Module, {
                            title: "Advanced React with TypeScript",
                            slug: "advanced-react-with-typescript",
                            metaLabel: "50+ exercises",
                            sub: "Expert-level knowledge for typing your React apps with TypeScript",
                            image: "https://cdn.sanity.io/images/z9io1e0u/production/bb6a657e3e8d8a8dc4d66783d23a56797b22b882-1200x1200.png",
                            children: [
                                _jsx(_components.p, {
                                    children: "Using TypeScript with React can be tricky, requiring flexible, type-safe, and structured components."
                                }),
                                _jsx(_components.p, {
                                    children: "This workshop empowers developers to combine React and TypeScript effectively. It covers advanced props handling, leveraging TypeScript generics for components and hooks, safer React hooks using types, understanding the TypeScript type system, recognizing industry-standard patterns, and safely integrating external libraries into React components."
                                })
                            ]
                        })
                    ]
                })
            }),
            "\n",
            _jsx(Buy, {}),
            "\n",
            _jsx(Companies, {}),
            "\n",
            _jsxs("section", {
                id: "feedback",
                className: "bg-gradient-to-b from-black relative to-background w-full sm:pb-24 pb-5 mt-40 flex flex-col items-center",
                children: [
                    _jsx("svg", {
                        className: "absolute top-[-60px]",
                        width: "1550",
                        height: "61",
                        viewBox: "0 0 1550 61",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: _jsx("path", {
                            d: "M0 60.35L775 0L1550 60.35H0Z",
                            fill: "#000"
                        })
                    }),
                    _jsx("h2", {
                        className: "px-5 text-balance sm:mb-24 mb-16 text-center not-prose mt-16 lg:text-5xl sm:text-4xl text-3xl font-medium font-heading max-w-3xl",
                        children: _jsx(_components.p, {
                            children: "See what fellow wizards have to say about Total TypeScript"
                        })
                    }),
                    _jsx("div", {
                        className: "not-prose flex flex-col items-center w-full",
                        children: _jsxs("div", {
                            className: "grid origin-top md:grid-cols-2 grid-cols-1 md:gap-16 sm:gap-10 gap-0 max-w-screen-lg w-full mx-auto px-5",
                            children: [
                                _jsx(Testimonial, {
                                    author: {
                                        name: 'Tomasz Łakomy',
                                        image: require('../../public/testimonials/tomasz-lakomy.jpg')
                                    },
                                    children: _jsx(_components.p, {
                                        children: "Total TypeScript by Matt Pocock is a masterpiece, 100% worth the money."
                                    })
                                }),
                                _jsx(Testimonial, {
                                    author: {
                                        name: 'Rares Golea',
                                        image: require('../../public/testimonials/rares-golea.jpg')
                                    },
                                    children: _jsxs(_components.p, {
                                        children: [
                                            _jsx(_components.strong, {
                                                children: "I truly feel like a wizard"
                                            }),
                                            " and I can’t stop recommending it!"
                                        ]
                                    })
                                }),
                                _jsx(Testimonial, {
                                    author: {
                                        name: 'John D. Jameson',
                                        image: require('../../public/testimonials/john-d-jameson.jpg')
                                    },
                                    children: _jsxs(_components.p, {
                                        children: [
                                            "I’m really digging Total TypeScript by Matt Pocock. It’s taking all the random TypeScript knowledge I’ve found in docs and Stack Overflow over the years and showing how it all works under the hood. ",
                                            _jsx(_components.strong, {
                                                children: "Highly recommended!"
                                            })
                                        ]
                                    })
                                }),
                                _jsx(Testimonial, {
                                    author: {
                                        name: 'Andrew C.',
                                        image: require('../../public/testimonials/andrew-cherniavskii.jpeg')
                                    },
                                    children: _jsxs(_components.p, {
                                        children: [
                                            "The challenges were not too easy, and some of them took me a fair amount of time to find a working solution. ",
                                            _jsx(_components.strong, {
                                                children: "This ultimately helped me to better understand TypeScript!"
                                            })
                                        ]
                                    })
                                }),
                                _jsx(Testimonial, {
                                    author: {
                                        name: 'Mr. Steal Your Code',
                                        image: require('../../public/testimonials/mr-steal-your-code.jpg')
                                    },
                                    children: _jsxs(_components.p, {
                                        children: [
                                            _jsx(_components.strong, {
                                                children: "Matt Pocock is saving my life with his Total TypeScript course."
                                            }),
                                            " Can't tell you how many other videos I've watched that didn't click as much as his have. Looking forward to the more advanced courses."
                                        ]
                                    })
                                }),
                                _jsx(Testimonial, {
                                    author: {
                                        name: 'Christopher Almeida-Symons',
                                        image: require('../../public/testimonials/christopher-almeida-symons.jpg')
                                    },
                                    children: _jsx(_components.p, {
                                        children: "After finishing the Total Typescript course by Matt Pocock: I love the UI and how he encourages something a lot of developers are not taught...reading docs. They are a powerful tool and should be encouraged to be used more."
                                    })
                                }),
                                _jsx(Testimonial, {
                                    author: {
                                        name: 'Sebastian Kasanzew',
                                        image: require('../../public/testimonials/sebastian-kasanzew.jpg')
                                    },
                                    children: _jsxs(_components.p, {
                                        children: [
                                            "These videos and exercises really ",
                                            _jsx(_components.strong, {
                                                children: "helped me to get to the next level in TS"
                                            }),
                                            ". I could improve types in some projects at work right on the next day."
                                        ]
                                    })
                                }),
                                _jsx(Testimonial, {
                                    author: {
                                        name: "Tal Faran"
                                    },
                                    children: _jsx(_components.p, {
                                        children: "Just finished all the Generics sections. Really enjoyed it! It covers realistic problems from our day to day work, and when you reach the end you have strong grasp of how to use generic more efficiently, and in a prettier way that is more accurate of what you wanted to achieve in the first place."
                                    })
                                }),
                                _jsx(Testimonial, {
                                    className: "md:col-span-2",
                                    author: {
                                        name: 'David Stinemetze',
                                        image: require('../../public/testimonials/david-stinemetze.png')
                                    },
                                    children: _jsxs(_components.p, {
                                        children: [
                                            "I’ve just completed the Type Transformations, Generics and Advanced Patterns workshops, and I can say ",
                                            _jsx(_components.strong, {
                                                children: "Total TypeScript is worth every penny"
                                            }),
                                            ". Matt’s mastery of the subject and ability to explain the more complex parts of TypeScript in an understandable way have fundamentally changed and expanded my understanding of the language. I feel armed with the knowledge and resources I need to solve ",
                                            _jsx("code", {
                                                className: "!bg-gray-700 rounded !px-1 py-0.5",
                                                children: "any"
                                            }),
                                            " TypeScript problem in front of me."
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            "\n",
            _jsxs("section", {
                id: "instructor",
                className: "max-w-screen-lg mx-auto w-full md:flex-row [&_img]:my-0 flex-col gap-5 mb-24 flex [&_h3]:mt-0",
                children: [
                    _jsx(Image, {
                        src: MattInNewStudio,
                        className: "w-full h-full rounded max-w-lg",
                        alt: "Matt Pocock",
                        loading: "eager",
                        quality: 100
                    }),
                    _jsxs("div", {
                        children: [
                            _jsx(_components.h3, {
                                children: "Hi, I'm Matt Pocock"
                            }),
                            _jsxs(_components.p, {
                                children: [
                                    "Before creating Total TypeScript, I was a member of the ",
                                    _jsx(_components.strong, {
                                        children: "XState"
                                    }),
                                    " core team and worked as a developer advocate at ",
                                    _jsx(_components.strong, {
                                        children: "Vercel"
                                    }),
                                    "."
                                ]
                            }),
                            _jsx(_components.p, {
                                children: "I've worked with TypeScript as a lead fullstack dev, a library maintainer, and now as a full-time educator."
                            }),
                            _jsx(_components.p, {
                                children: "I built Total TypeScript to make the secrets of open-source maintainers and industry experts available to everyone."
                            })
                        ]
                    })
                ]
            }),
            "\n",
            _jsx("div", {
                className: "bg-gradient-to-t from-transparent to-white/10 border-t border-x rounded-t-lg border-white/10 sm:px-10 px-2 sm:pb-16 pb-24",
                children: _jsxs("div", {
                    className: "flex md:flex-row flex-col-reverse max-w-screen-lg mx-auto w-full items-start",
                    children: [
                        _jsxs("div", {
                            children: [
                                _jsx("h3", {
                                    className: "not-prose mb-8 text-balance px-5 md:pt-20 pt-0 md:mt-0 -mt-48 text-center font-heading text-4xl font-semibold md:text-left",
                                    children: _jsx(_components.p, {
                                        children: "Who is Total TypeScript for?"
                                    })
                                }),
                                _jsx(_components.p, {
                                    children: "Total TypeScript is suitable for any developer who is ready to work at becoming a wizard, though some basic familiarity with TypeScript is recommended."
                                }),
                                _jsx(_components.p, {
                                    children: "The Type Transformations workshop begins by warming you up with exercises on basic inference and essential types."
                                }),
                                _jsx(_components.p, {
                                    children: "Then nearly 150 exercises later, the Advanced TypeScript Patterns workshop will have you creating chainable method abstractions with generics and the builder pattern."
                                }),
                                _jsxs(_components.p, {
                                    children: [
                                        "Check out the free ",
                                        _jsx(_components.a, {
                                            href: "/tutorials/beginners-typescript",
                                            children: "Beginner's Tutorial"
                                        }),
                                        " to set a foundation and get an idea for the workshop's teaching approach."
                                    ]
                                })
                            ]
                        }),
                        _jsx(Image, {
                            src: Wand,
                            alt: "a wand",
                            width: 444,
                            height: 586,
                            className: "relative md:-translate-y-28 md:mt-0 -mt-16 -scale-x-100"
                        })
                    ]
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = Object.assign({}, _provideComponents(), props.components);
    return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
        children: _jsx(_createMdxContent, props)
    })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
    throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
